import { render, staticRenderFns } from "./ActionComponent.vue?vue&type=template&id=70c5b1fa&scoped=true&"
import script from "./ActionComponent.vue?vue&type=script&lang=js&"
export * from "./ActionComponent.vue?vue&type=script&lang=js&"
import style0 from "./ActionComponent.vue?vue&type=style&index=0&id=70c5b1fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c5b1fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c5b1fa')) {
      api.createRecord('70c5b1fa', component.options)
    } else {
      api.reload('70c5b1fa', component.options)
    }
    module.hot.accept("./ActionComponent.vue?vue&type=template&id=70c5b1fa&scoped=true&", function () {
      api.rerender('70c5b1fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/referralPage/partials/ActionComponent.vue"
export default component.exports